import { jsx as o } from "react/jsx-runtime";
import { DealCard as _ } from "../DealCard/index.js";
import { DealHeaderFeaturedCommentAction as g } from "../../../../types/Deal/index.js";
import { HeaderFeaturedComment as u } from "../components/HeaderFeaturedComment/index.js";
import { DealFeedCardActions as x } from "../components/DealFeedCardActions/index.js";
const j = ({
  id: r,
  status: t,
  commentCount: m,
  temperature: C,
  commentId: n,
  authorImage: d,
  authorNickname: i,
  content: l,
  contentLabel: f,
  isAuthorVerified: p,
  voteInfo: D,
  dispatch: e,
  dealUrl: H,
  commentsDealUrl: c,
  locale: a,
  cashbackPercentage: A,
  ...s
}) => {
  const E = () => /* @__PURE__ */ o(
    u,
    {
      commentId: n,
      authorImage: d,
      authorNickname: i,
      content: l,
      contentLabel: f,
      isVerified: p,
      onClick: () => e({
        type: g.ON_HEADER_COMMENT_CLICK,
        payload: { commentId: n }
      })
    }
  ), F = () => /* @__PURE__ */ o(
    x,
    {
      deal: {
        id: r,
        status: t,
        commentCount: m,
        temperature: C
      },
      voteInfo: D,
      actionHandler: e,
      commentsDealUrl: c,
      locale: a
    }
  );
  return /* @__PURE__ */ o(
    _,
    {
      id: r,
      status: t,
      dispatch: e,
      headerContent: E(),
      bottomContent: F(),
      dealUrl: H,
      locale: a,
      cashbackPercentage: A,
      ...s
    }
  );
};
export {
  j as DealCardComment
};
